import { Component, OnInit } from '@angular/core';
import { AuthService } from '@services';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.page.html',
  styleUrls: ['./sso.page.scss'],
})
export class SsoPage implements OnInit {

  constructor(
    public authService: AuthService
  ) {
  }

  ngOnInit() {

  }

}
